// Client proof (spec c.7 §3 and §7). Founder/COO decisions 2026-10-09:
// Hirotec and Mane only, logos ON, all quotes OFF (no quote strings exist in any language).

export type ClientQuote = {
  /** i18n key of the quote text (e.g. "testimonials.hirotec.text"). Add it in all four languages first. */
  textKey: string;
  person: string;
  /** i18n key of the person's title. */
  titleKey: string;
  quoteConsent: boolean;
};

export type Client = {
  id: "hirotec" | "mane";
  name: string;
  /** Public path of the processed logo (trimmed, 2× logoHeight, PNG ≤ 12 KB). */
  logo: string;
  /** Rendered logo height in px at 1×. */
  logoHeight: number;
  /** Rendered logo width in px at 1× (from the processed asset's ratio). */
  logoWidth: number;
  logoConsent: boolean;
  /** Only Hirotec may carry a quote; renders only with consent + person + title. */
  quote?: ClientQuote;
};

export const clients: Client[] = [
  {
    id: "hirotec",
    name: "Hirotec",
    logo: "/assets/clients/hirotec.png", // trimmed, 68×88 → 34×44 at 1× (re-score fix 8)
    logoHeight: 44,
    logoWidth: 34,
    logoConsent: true,
  },
  {
    id: "mane",
    name: "Mane",
    logo: "/assets/clients/mane.png", // 173×40 → 87×20 at 1×
    logoHeight: 20,
    logoWidth: 87,
    logoConsent: true,
  },
];

export const logoClients = (list: Client[] = clients): Client[] =>
  list.filter((c) => c.logoConsent);

export const quotedClient = (list: Client[] = clients): Client | undefined =>
  list.find((c) => c.quote?.quoteConsent && c.quote.person && c.quote.titleKey);
